var VideoEditorComponent = new JS.Class(EditorComponent, {
  initialize: function(videoEditorDataSelector) {
    this.videoEditorDataSelector = videoEditorDataSelector;
  },

  getSaveData: function() {
    var videoEditorData = $(this.videoEditorDataSelector).val();

    return {
      VideoEditor: videoEditorData,
    };
  },
});
